<template>
	<div class="page locations">
		<!-- Locations Banner -->
		<div class="locations-banner">
			<div class="locations-banner-img">
				<img :src="bannerList[0]?.img || require('../../assets/homeMb/swiper-mobile.png')" alt=""></img>
			</div>
			<div class="locations-banner-text">
				<h5 class="caption-text">{{ $t('home.oneCont.title') }}</h5>
				<p class="caption-description">{{ $t('home.oneCont.cont') }}</p>
				<!-- <div class="carousel-caption-btn">{{ $t('home.oneCont.btn') }}</div> -->
			</div>
			<div class="carousel-information" @click="openInquiryForm">
				<img src="../../assets/home/xinxi.png" alt="">
			</div>
		</div>

		<!-- Locations GoogleMap -->
		<div class="locations-google-map">
			<div class="area-title-mobile">
				<p class="area-titleTop-mobile">{{ pageData[0]?.value[0]?.title }}</p>
				<p class="area-titleBottom-mobile">{{ pageData[0]?.value[0]?.subheading }}</p>
			</div>
			<div class="home-locations-map">
				<div class="home-locations-map-item">
					<!-- Google Maps 组件 -->
					<GmapMap :center="center" :zoom="zoom" style="width: 100%; height: 100%"
						:options="{ disableDefaultUI: true }">
						<!-- 地图标记点 -->
						<GmapMarker v-for="(marker, index) in locationsList[0]?.value[0]?.content" :key="index"
							:position="marker.latitude_and_longitude" :icon="{
								url: require('@/assets/home/dw.png'),
								scaledSize: { width: 50, height: 50 }
							}" @click="onMarkerClick(marker)" />
						<!-- 用户当前位置标记 -->
						<GmapMarker v-if="userLocation" :position="userLocation" :icon="userIcon" />

						<!-- 信息窗口 -->
						<GmapInfoWindow v-if="selectedMarker" :options="{ maxWidth: '500', width: '500' }"
							:position="selectedMarker.latitude_and_longitude" @closeclick="onInfoWindowClose"
							:visible="isInfoWindowVisible">
							<div class="info-window-content">
								<div class="info-window-avater">
									<img :src="selectedMarker.icon" alt="">
								</div>
								<div class="info-window-titleCont">
									<h5>{{ selectedMarker.name }}</h5>
									<span>{{ selectedMarker.url }}</span>
								</div>
								<div class="info-window-body">
									<div class="info-window-footer">
										<button @click="navigateToLocation(selectedMarker)"><i
												class="el-icon-right"></i></button>
									</div>
								</div>
							</div>
						</GmapInfoWindow>
					</GmapMap>
				</div>
				<div class="home-locations-map-item home-locations-map-item-list">
          <div class="locations-list">
            <el-card class="locations-list-card" v-for="(item, index) in locationsList[0]?.value[0]?.content" :key="index">
              <div class="info-window-card-content">
                <div class="info-window-card-avater">
                  <img :src="item.icon" alt="">
                </div>
                <div class="info-window-card-titleCont">
                  <h5>{{ item.name }}</h5>
                  <p>{{ $t('franchise.countries.label') + ' ' + item.url }}</p>
                  <p>{{ $t('franchise.countries.label1') + ' ' + item.mobile }}</p>
                </div>
                <div class="info-window-card-body">
                  <div class="info-window-card-footer">
                    <button @click="navigateToLocation(item)">
                      <i class="el-icon-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </div>
			</div>
		</div>
	</div>
</template>
<script>
import { bus } from '@/utils/bus';
import { getDataList, getBannerListingMobile } from '@/api/komo.js';
export default {
	data() {
		return {
			locations: [],
			bannerList: [],
			pageData: [],
			locationsList: [],
			// locations ================================
			center: { lat: 1.3521, lng: 103.8198 }, // 新加坡坐标
			zoom: 6,
			selectedMarker: null,
			userLocation: null,
			isInfoWindowVisible: true,
			userIcon: {
				url: require('@/assets/home/dqdw.png'),
				scaledSize: { width: 88, height: 88 }
			},
			markers: [
				{
					name: '新加坡',
					position: { lat: 1.3521, lng: 103.8198 },
					icon: {
						url: require('@/assets/home/dw.png'),
						scaledSize: { width: 50, height: 50 }
					},
					description: '新加坡共和国'
				},
				{
					name: '马来西亚',
					position: { lat: 3.1497, lng: 101.6942 },
					icon: {
						url: require('@/assets/home/dw.png'),
						scaledSize: { width: 50, height: 50 }
					},
					description: '马来西亚联邦'
				},
				{
					name: '泰国',
					position: { lat: 13.7563, lng: 100.5018 },
					icon: {
						url: require('@/assets/home/dw.png'),
						scaledSize: { width: 50, height: 50 }
					},
					description: '泰王国'
				},
				{
					name: '印度尼西亚',
					position: { lat: -6.2088, lng: 106.8456 },
					icon: {
						url: require('@/assets/home/dw.png'),
						scaledSize: { width: 50, height: 50 }
					},
					description: '印度尼西亚共和国'
				}
			]

			// locations end ================================
		}
	},
	mounted() {
		// 页面加载时尝试获取用户位置
		this.getCurrentPosition();
	},
	created() {
		this.initData()
	},
	methods: {
		async initData() {
			const res = await getBannerListingMobile('5')
			if (res.error == 0) {
				this.bannerList = res?.data?.list || [];
			}

			const res1 = await getDataList(localStorage?.getItem('pageId'))
			this.pageData = res1?.data?.list || [];
			this.locationsList = res1?.data?.list || []
			this.locationsList[0].value[0].content.forEach(item => {
				try {
					if (item.latitude_and_longitude) {
						const coords = item.latitude_and_longitude.split(',')
						if (coords.length === 2) {
							item.latitude_and_longitude = {
								lat: parseFloat(coords[0].trim()),
								lng: parseFloat(coords[1].trim())
							}
						}
					}
				} catch (e) {
					console.error('经纬度转换错误:', e)
					item.coordinates = null
				}
			})
		},
		openInquiryForm() {
			bus.$emit('inquiry-form', true)
		},

		// 谷歌地图
		// 获取用户当前位置
		getCurrentPosition() {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						const lat = position.coords.latitude;
						const lng = position.coords.longitude;

						this.userLocation = { lat, lng };
						this.center = { lat, lng };
						this.zoom = 1.5;

						console.log('用户位置:', lat, lng);
					},
					(error) => {
						console.error('获取位置失败:', error);
						alert('无法获取您的位置，请检查浏览器设置');
					},
					{
						enableHighAccuracy: true, // 高精度
						timeout: 10000, // 超时时间
						maximumAge: 0 // 不缓存位置
					}
				);
			} else {
				alert('您的浏览器不支持地理位置功能');
			}
		},
		// 点击标记点事件
		onMarkerClick(marker) {
			console.log('点击', marker)
			this.selectedMarker = marker;
			this.isInfoWindowVisible = true;
			console.log('信息窗口状态:', this.isInfoWindowVisible);
		},
		onInfoWindowClose() {
			console.log('关闭')
			this.isInfoWindowVisible = false;
			this.selectedMarker = null; // 清除选中的标记
		},
		navigateToLocation(marker) {
			// this.center = marker.position;
			// this.zoom = 12;
			window.open('https://www.baidu.com/', '_blank', 'noopener,noreferrer');
      this.isInfoWindowVisible = false;
      this.selectedMarker = null; // 同时清除选中状态
		}
	},
}
</script>
<style scoped>
.locations {
	width: 100%;
	background: #F8F9FC;
}

/* Locations Banner */
.locations-banner {
	width: 100%;
	position: relative;
}

.locations-banner .locations-banner-img {
	width: 100%;
}

.locations-banner-img img {
	width: 100%;
	height: 100%;
}

.locations-banner-text {
	position: absolute;
	left: 50%;
	top: 10%;
	transform: translateX(-50%);
	text-align: center;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.locations-banner-text .caption-text {
	font-size: 6vw;
	font-weight: 800;
	color: #1e1e1e;
}

.locations-banner-text .caption-description {
	font-weight: 100;
	font-size: 3.5vw;
	color: #1e1e1e;
}

.locations-banner-text .carousel-caption-btn {
	width: 30vw;
	height: 10vw;
	border-radius: 20px;
	border: 1px solid #979797;
	font-size: 1rem;
	color: #FFFFFF;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	background-color: #1e1e1e;
}

.locations-banner .carousel-information {
	position: fixed;
	bottom: 3%;
	right: 3%;
	width: 25vw;
	height: 25vw;
	cursor: pointer;
	z-index: 999;
}

.locations-banner .carousel-information img {
	width: 100%;
	height: 100%;
}

/*  Locations GoogleMap */
.locations-google-map {
	width: 100%;
	padding: 20px;
}

.home-locations-map {
	width: 100%;
	height: 100%;
	/* border: 1px solid #000000;
    position: relative; */
}
.home-locations-map-item{
  width: 100%;
  height: 600px;
}
.home-locations-map-item-list{
  width: 100%;
 	height: auto;
	margin-top: 5%;
}
.locations-list{
  width: 100%;
  height: 100%;
  padding: 0% 2% 0 0 ;
  /* overflow-y: auto; */
}
.locations-list::-webkit-scrollbar-track {
  border-radius: 5px;
  background: transparent;
  box-shadow: inset 0 0 3px rgba(0,0,0,0.1);
  border-radius: 10px;
}
.locations-list::-webkit-scrollbar {
  width: 8px;       /* 竖向滚动条宽度 */
  height: 10px;      /* 横向滚动条高度 */
  background: transparent; /* 轨道背景色 */
}
.locations-list::-webkit-scrollbar-thumb {
  background: #a1a1a1;
  border-radius: 5px;
  border: 2px solid transparent; /* 透明边框增强视觉效果 */
  background-clip: content-box;  /* 避免背景色溢出 */
}

/* 滑块悬停状态 */
.locations-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 滚动条角落 */
.locations-list::-webkit-scrollbar-corner {
  background: transparent;
}
.locations-list-card{
  width: 100%;
  height: 24%;
  margin-bottom: 2%;
  border-radius: 10px;
}

.home-locations-map .info-window-content {
	padding: 10px;
	font-size: 14px;
	background-color: white;
	border-radius: 8px;
	display: flex;
	flex-direction: row;
	gap: 3%;
	align-items: center;
}

.info-window-avater {
	width: 75px;
	height: 60px;
}

.info-window-avater img {
	width: 100%;
	height: 100%;
	border-radius: 10px;
	object-fit: cover;
}

.info-window-titleCont {
	width: 70%;
}

.home-locations-map .info-window-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
}

.home-locations-map .close-button {
	background: none;
	border: none;
	font-size: 20px;
	cursor: pointer;
	color: #999;
}

.home-locations-map .close-button:hover {
	color: #333;
}

.home-locations-map .info-window-body {
	margin-bottom: 10px;
	display: flex;
	align-items: center;
}

.home-locations-map .info-window-footer {
	text-align: right;
}

.home-locations-map .info-window-footer button {
	padding: 5px 10px;
	background-color: #1e1e1e;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 1.5vw;
}

.home-locations-map .info-window-footer button:hover {
	background-color: #000;
}

.home-locations-map-item-list .info-window-card-content {
  font-size: 1.2vw;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  gap: 2%;
  align-items: center;
}
.home-locations-map-item-list .info-window-card-avater{
  width: 9%;
  /* height: 4vw; */
}
.home-locations-map-item-list .info-window-card-avater img{ 
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}
.info-window-card-titleCont h5{
  font-size: 1rem;
  color: #1e1e1e;
  margin-bottom: 0.1vw;
}
.info-window-card-titleCont p{
  font-size:0.8rem;
  color: #959595;
  margin: 0;
}
.home-locations-map-item-list .info-window-card-body {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
}

.home-locations-map-item-list .info-window-card-footer {
  text-align: right;
}

.home-locations-map-item-list .info-window-card-footer button {
  padding: 0.1rem 0.6rem;
  background-color: #1e1e1e;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.5rem;
}

.home-locations-map-item-list .info-window-card-footer button:hover {
  background-color: #000;
}
</style>